import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Loader2, Sparkles, Columns3 } from 'lucide-react';
import { Button } from '../ui/button';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/** Client matrix columns (dependencies / licensing / effort / limitations …) — editable, AI auto-fill from the drafted answer + chosen response mode. */
export const MatrixColumns = ({ q, docId, projectId, extraColumns, onUpdate }) => {
  const [busy, setBusy] = useState(false);
  const [edits, setEdits] = useState(null);
  const vals = edits || q.matrix_cols || {};
  const fill = async () => {
    setBusy(true);
    try {
      const r = await axios.post(`${API_URL}/api/rfp/response/projects/${projectId}/documents/${docId}/questions/${q.idx}/matrix-fill`, {}, { withCredentials: true });
      setEdits(null);
      onUpdate?.(docId, q.idx, null, { matrix_cols: r.data.matrix_cols, matrix_cols_ai: true });
      toast.success('Matrix columns drafted from your answer — review and adjust');
    } catch (err) { toast.error(err?.response?.data?.detail || 'Could not auto-fill'); }
    finally { setBusy(false); }
  };
  const save = () => { if (edits) { onUpdate(docId, q.idx, { matrix_cols: edits }); setEdits(null); } };
  return (
    <div className="bg-slate-50 border border-slate-100 rounded-md px-2 py-1.5 space-y-1" data-testid={`rfp-matrix-cols-${docId}-${q.idx}`}>
      <div className="flex items-center gap-2 flex-wrap">
        <span className="text-[10px] font-semibold text-slate-500 uppercase tracking-wide inline-flex items-center gap-1"><Columns3 className="w-3 h-3" />Client matrix columns</span>
        {q.matrix_cols_ai && <span className="text-[9px] text-violet-700 bg-violet-50 border border-violet-200 rounded-full px-1.5" data-testid={`rfp-matrix-cols-ai-${docId}-${q.idx}`}>AI drafted</span>}
        <span className="ml-auto flex items-center gap-1">
          {edits && <Button size="sm" variant="outline" className="h-5 text-[10px] px-2" onClick={save} data-testid={`rfp-matrix-cols-save-${docId}-${q.idx}`}>Save</Button>}
          <Button size="sm" variant="outline" className="h-5 text-[10px] px-2 text-violet-700 border-violet-200 hover:bg-violet-50" onClick={fill} disabled={busy} data-testid={`rfp-matrix-cols-fill-${docId}-${q.idx}`}>
            {busy ? <Loader2 className="w-3 h-3 mr-1 animate-spin" /> : <Sparkles className="w-3 h-3 mr-1" />}Auto-fill
          </Button>
        </span>
      </div>
      <div className="grid gap-1" style={{ gridTemplateColumns: `repeat(${Math.min(4, extraColumns.length)}, minmax(0, 1fr))` }}>
        {extraColumns.map((c) => (
          <label key={c} className="text-[10px] text-slate-500 min-w-0">
            <span className="capitalize">{c}</span>
            <input value={vals[c] || ''} placeholder="—" onChange={(e) => setEdits({ ...vals, [c]: e.target.value })} onBlur={save}
              className="mt-0.5 w-full h-6 text-[10px] border border-slate-200 rounded px-1.5 bg-white text-slate-700" data-testid={`rfp-matrix-col-${docId}-${q.idx}-${c.replace(/\s+/g, '-')}`} />
          </label>
        ))}
      </div>
    </div>
  );
};
